import React, { memo } from 'react'
import cn, { Argument as ClassName } from 'classnames'
import { Link, useSearchParams } from 'react-router-dom'

import { PageLayoutContainer } from '../../../lib/page-layout-container'
import { LandingMessageErrorIcon } from '../../../lib/icons/landing-message-error-icon'
import useText from '../../../common/hooks/useText'

export type BillingFailedPageProps = {
    className?: ClassName
    style?: React.CSSProperties
}

export const BillingFailedPage = memo(function BillingFailedPage({
    className,
    style,
}: BillingFailedPageProps): React.ReactElement {
    const text = useText()

    const [searchParams] = useSearchParams()
    const reasonParam = searchParams.get('reason')

    const titleKeyByReason: Record<string, string> = {
        timeout: 'lblBillingPlanActivationFailedTimeout',
        bad_request: 'lblBillingPlanActivationFailedBadRequest',
        server_error: 'lblBillingPlanActivationFailedServerError',
        network_error: 'lblBillingPlanActivationFailedNetworkError',
        unknown: 'lblBillingPlanActivationFailedUnknown',
    }

    const titleKey = titleKeyByReason[reasonParam ?? ''] ?? 'lblBillingPlanActivationFailedUnknown'

    const containerClassName = 'flex justify-content-center align-items-center flex-column gap-4'
    const containerStyle: React.CSSProperties = { height: '33vh' }

    return (
        <PageLayoutContainer className={cn(className)} style={style}>
            <div className={containerClassName} style={containerStyle}>
                <LandingMessageErrorIcon />

                <h4 className="m-0 mb-3">{text('lblBillingPlanActivationFailedTitle')}</h4>

                <p>{text(titleKey)}</p>

                <Link data-testid="linkBtn" to="/billing">
                    {text('lblBackToRoute', { route: text('lblBilling') })}
                </Link>
            </div>
        </PageLayoutContainer>
    )
})
